export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/internet.worker.785e9941.worker.js");
}
